import styled from "styled-components";

export const ScheduleDaysWrapper = styled.div`
    .schedule-days-input {
        width: 4.5rem;
    }
`;
